<template>
    <div class="row">
        <div class="col-12">
            <h5 class="pt-1">{{ data.title }}</h5>
        </div>
        <div class="col-12 col-sm-7">
            <h6 v-if="data.hotelName">{{data.hotelName}}</h6>
            <span v-if="data.hotelClassification && data.hotelClassification.classificationVisible"
                  class="classification inline mb-3">
                    <StarIcon v-for="(star, index) in data.hotelClassification.classificationValue"
                              :key="'star' + index" class="star-svg"/>
                    <span v-if="data.hotelClassification.classificationSuperior" class="superior"
                          tooltip="Superior">S</span>
                    <span
                        v-if="data.hotelClassification.estimatedClassification"
                        class="animod-stars"
                        tooltip="Die Klassifizierung basiert auf einer Selbsteinschätzung des Hotels bzw. Erfahrungen von Kunden."
                    >
                        Animod-Sterne
                    </span>
                </span>
            <ul class="checklist details-list text-left">
                <li v-for="(item, index) in data.services" :key="'srv' + index">
                    <TickIcon class="icon-tick" />
                    <slot :item="item" :index="index">
                        <span v-html="item"></span>
                    </slot>
                </li>
            </ul>
        </div>
        <div class="col-12 col-xs-12 col-sm-5">
            <img :src="data.imageUrl" width="100%" class="mb-3"/>
            <dl>
                <span v-for="(item, index) in data.details" :key="'item' + index">
                    <dt valign="top">{{ item.first }}</dt>
                    <dd valign="top" class="text-left">{{ item.second }}</dd>
                </span>
            </dl>
        </div>
    </div>
</template>

<script>
import TickIcon from '../../../animod-shop-ssr/src/assets/icons/tick.svg';
import StarIcon from '../../../animod-shop-ssr/src/assets/icons/star.svg';
import FinishOrderForm from "@/components/FinishOrderForm.vue";

export default {
    name: 'OrderDetails',
    components: {FinishOrderForm, TickIcon, StarIcon},
    data() {
        return {}
    },
    props: {
        data: {
            type: Object,
            default() {
                return {
                    title: "",
                    rating: 0,
                    ratingSuffix: null,
                    imageUrl: "",
                    total: 0,
                    details: [],
                    services: []
                };
            }
        }
    },
    computed: {},
    methods: {}
}
</script>

<style scoped lang="scss">
h6 {
    font-weight: bold;
    margin-bottom: .2rem;
}
dl {
    dt {
        color: #999;
        text-transform: uppercase;
        font-size: 10px;
        line-height: 10px;
    }
    dd {

    }
}
ul.checklist {
    padding: 0;
    list-style: none;
    list-style-position: inside;
    $line-height: 1.5em;
    $padding-y: 0.5em;
    li {
        position: relative;
        padding: 0 0 $padding-y 2em;
        line-height: $line-height;

        .icon-tick {
            fill: hsl(25, 100%, 60%);
            width: 1em;
            height: $line-height;
            position: absolute;
            top: 0;
            left: 0;
        }
    }
}
.classification {
    font-size: inherit;
    display: flex;
    align-items: center;

    .star-svg {
        width: 1em;
        height: 1em;
        fill: currentColor;

        &:not(:last-of-type) {
            margin-right: 0.15em;
        }
    }

    .superior {
        margin-left: 5px;
        font-size: 0.6em;
        text-decoration: none;
    }

    .animod-stars {
        position: relative;
        top: 0;
        white-space: nowrap;
        margin-left: 5px;

        &.below {
            position: absolute;
            top: 1.75em;
            line-height: 1.5em;
            font-size: 0.6em;
            margin-left: 0;
        }
    }

    &.inline {
        .animod-stars {
            white-space: normal;
            max-width: 4em;
            display: block;
            line-height: 1;
            font-size: 12px;
            text-align: center;
            margin-left: 3px;
        }

        .superior {
            font-size: 1em;
            line-height: normal;
        }
    }
}
</style>
